import { createPortal } from 'react-dom';
import { cx } from '@/utils/cx';
import { CrystalMark } from '@/assets/icons';
import { useOverlayPortalNode } from '@/providers/OverlayPortalProvider';
import styles from './SuccessOverlay.module.scss';

export interface SuccessOverlayProps {
  isOpen: boolean;
  title: string;
  message: string;
  onDone: () => void;
}

// Portaled into the app-shell overlay root for the same reason as
// BottomSheet: it's triggered from inside a scrollable page, but
// needs to cover the whole app regardless of that page's scroll
// position.
export function SuccessOverlay({ isOpen, title, message, onDone }: SuccessOverlayProps) {
  const portalNode = useOverlayPortalNode();
  if (!portalNode) return null;

  return createPortal(
    <div className={cx(styles.overlay, isOpen && styles.show)} role="status" aria-live="polite">
      <CrystalMark size={120} height={150} className={styles.crystal} revealed={isOpen} />
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.message}>{message}</p>
      <button type="button" className={styles.done} onClick={onDone}>
        Done
      </button>
    </div>,
    portalNode,
  );
}
